/**
 * Created by jv on 24/04/2017.
 */
//js
const Shared = require("Sources/shared");
const StoreShared = require("Sources/store-shared");
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const UserTypeSelectionTemplate = require("Sources/templates/user-type-selection.template");
const StoreServices = require("Sources/services/fundels/store-services");
const StorageController = require("Sources/services/storage-controller");

//Styles (Load module specific style after js - some modules (shared.js in this case) contain global css)
// --> order of require calls matters!!
require("Styles/pages/store/user-type-selection.scss");

$(function()
{
  //Initialze stuff
  LanguageManager.init(function()
  {
    StoreShared.init(function()
    {
      userTypeSelection.init();
    }, true);
  }, Shared.defaultLocale);
});

var userTypeSelection = {};

(function(UserTypeSelection)
{
  var catalogs;

  var utsTemplate;

  UserTypeSelection.init = function()
  {
    getCatalogs(function()
    {
      setUpUserTypeSelection();

      setUpContinueBtn();
    });
  };

  function setUpUserTypeSelection()
  {
    utsTemplate = new UserTypeSelectionTemplate({
      appendTo: $("#user-selection-wrapper"),
      userTypes: getUserTypesFromCatalogs(),
      onCountrySelected: function(country)
      {
        utils.devLog(country);
        if(utils.isNotNull(utsTemplate.selectedUserType))
        {
          $("#continue-btn").show();
        }
        else
        {
          $("#continue-btn").hide();
        }
      },
      onUserTypeSelected: function(userType)
      {
        utils.devLog(userType);
        if(utils.isNotNull(userType))
        {
          $("#continue-btn").show();
        }
        else
        {
          $("#continue-btn").hide();
        }
      }
    });
  }

  function getUserTypesFromCatalogs()
  {
    var countries = [];
    var countryKeys = [];

    for(var i = 0; i < catalogs.length; i++)
    {
      if($.inArray(catalogs[i].locale, countryKeys) === -1)
      {
        countryKeys.push(catalogs[i].locale);

        countries.push({
          locale: catalogs[i].locale,
          displayText: StoreShared.getReadableLocale(catalogs[i].locale),
          userTypes: []
        });
      }
    }

    for(var x = 0; x < countries.length; x++)
    {
      for(var y = 0; y < catalogs.length; y++)
      {
        if(catalogs[y].locale === countries[x].locale)
        {
          countries[x].userTypes.push({
            key: catalogs[y].type,
            displayText: StoreShared.getReadableUserType(catalogs[y].type),
            locale: catalogs[y].locale,
            infoUrl: catalogs[y]["info-url"],
            catalogUrl: catalogs[y]["catalog-url"]
          });
        }
      }
    }

    return countries;
  }

  function setUpContinueBtn()
  {
    $("#continue-btn").on("click", function(e)
    {
      if(utils.isNotNull(utsTemplate.selectedUserType))
      {
        // var currentUserLocale = StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
        // var currentUserType = StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);
        //
        // if(StoreShared.sessionData.cart.itemCount > 0 && (utsTemplate.selectedUserType.locale !== currentUserLocale || utsTemplate.selectedUserType.key !== currentUserType))
        // {
        //   Shared.Dialog.showYesNoDialog("store.change_user_type.confirmation.title", "store.change_user_type.confirmation.text", function()
        //   {
        //     goToStoreInfo(utsTemplate.selectedUserType);
        //   });
        // }
        // else
        // {
        //   goToStoreInfo(utsTemplate.selectedUserType);
        // }

        goToStoreInfo(utsTemplate.selectedUserType);
      }
    });
  }

  function goToStoreInfo(userType)
  {
    utils.devLog(userType);

    StorageController.saveToLocal(StorageController.keys.STORE_USER_LOCALE, userType.locale);
    StorageController.saveToLocal(StorageController.keys.STORE_USER_TYPE, userType.key);

    if(utils.isNotNull(userType.infoUrl))
    {
      utils.redirect(userType.infoUrl);
    }
    else
    {
      utils.redirect(userType.catalogUrl);
    }
  }

  function getCatalogs(callback)
  {
    StoreServices.getCatalogList(
      function(data)
      {
        // Success
        catalogs = data;

        utils.devLog("Catalogs: %o", catalogs);

        if(utils.isFunction(callback))
        {
          callback();
        }
      },
      function(data)
      {
        // Fail
        Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
        console.error("Failed to get catalog list");
      }
    );
  }

}(userTypeSelection));



// WEBPACK FOOTER //
// ./app/js/entries/store/user-type-selection.js